import { Reducer } from 'redux';
import { CALL_API } from '../helpers/middleware/api';
import createRequestTypes from '../helpers/createRequestTypes'


const LOGIN_REQUEST = createRequestTypes('LOGIN_REQUEST');

export const loginRequest = (email: string) => ({
  [CALL_API]: {
    types: LOGIN_REQUEST,
    endpoint: '/api/v2.0/users/_request_authentication_token',
    noJson: true,
    options: {
      method: 'POST',
      body: JSON.stringify({ email }),
    }
  }
})

export const reset = () => ({ type: 'LOGIN_REQUEST_RESET' })


export interface LoginRequestState {
  requested: boolean;
  requesting: boolean;
  success: boolean;
  error: string;
}

const initialState: LoginRequestState = {
  requested: false,
  requesting: false,
  success: false,
  error: null,
}

const reducer: Reducer<LoginRequestState> = (state = initialState, action): LoginRequestState => {
  switch(action.type) {
    case LOGIN_REQUEST.REQUEST:
      return { requested: true, requesting: true, success: false, error: null }
    case LOGIN_REQUEST.SUCCESS:
      return { requested: true, requesting: false, success: true, error: null }
    case LOGIN_REQUEST.FAILURE:
      return { requested: true, requesting: false, success: false, error: action.error.errors[0] }
    case 'LOGIN_REQUEST_RESET':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
